import { render, staticRenderFns } from "./CreateApp.vue?vue&type=template&id=7b128c68&scoped=true"
import script from "./CreateApp.vue?vue&type=script&lang=js"
export * from "./CreateApp.vue?vue&type=script&lang=js"
import style0 from "./CreateApp.vue?vue&type=style&index=0&id=7b128c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b128c68",
  null
  
)

export default component.exports